import axios, {type AxiosInstance } from 'axios';
import { API_BASE_URL } from './endpoints';
import { getSubdomain, getLocalStoreage } from "../helpers";

export interface ApiClientOptions {
	baseURL?: string;
	timeoutMs?: number;
	onAuthFailure?: () => void;
}

const DEFAULT_OPTS: Required<Omit<ApiClientOptions, "onAuthFailure">> = {
	baseURL: "",
	timeoutMs: 30000,
};

export const httpClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

httpClient.interceptors.request.use((config) => {
  	// Attach auth tokens or other headers if needed
  	const subdomain = getSubdomain();
  	const configData = getLocalStoreage(`configData_${subdomain}`);
	if (configData && configData.client_uuid) {
		config.headers["x-ivt-key"] = configData.client_uuid;	
	}

  	return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle global errors/logging
    return Promise.reject(error);
  }
);

export function setupGlobalAxios(opts: ApiClientOptions = {}): void {
	const options = {...DEFAULT_OPTS, ...opts};
	const globalAxios = axios as typeof axios & { __ule360_refresh_setup__?: boolean };
	if (globalAxios.__ule360_refresh_setup__) return;
	globalAxios.__ule360_refresh_setup__ = true;

	// Prefer provided baseURL, otherwise derive from runtime EnvConfig or Vite env
	const inferredBaseURL = API_BASE_URL ?? "";
	axios.defaults.baseURL = options.baseURL || inferredBaseURL || axios.defaults.baseURL;
	axios.defaults.timeout = options.timeoutMs;
}

// Initialize global interceptors on import
setupGlobalAxios();
